/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Stat_QueriesInputs */

const en_landing_preview_stat_queries = /** @type {(inputs: Landing_Preview_Stat_QueriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client queries`)
};

/**
* | output |
* | --- |
* | "Client queries" |
*
* @param {Landing_Preview_Stat_QueriesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_stat_queries = /** @type {((inputs?: Landing_Preview_Stat_QueriesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Stat_QueriesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_stat_queries(inputs)
});